import { useState, useEffect } from 'react'
import { apiFetch } from '../lib/api'

interface Hotel {
  id: string
  name: string
  address: string
  chain: string
  rate: number
  lat: number
  lng: number
}

export function Hotels() {
  const [hotels, setHotels] = useState<Hotel[]>([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetchHotels()
  }, [])

  async function fetchHotels() {
    try {
      const data = await apiFetch('/api/hotels')
      setHotels(data.hotels)
    } catch {}
    setLoading(false)
  }

  if (loading) return <div className="page"><p>Loading hotels...</p></div>

  return (
    <div className="page hotels">
      <header className="header">
        <h1>Partner Hotels</h1>
        <p>£44/night at all partner chains</p>
      </header>

      {hotels.length === 0 ? (
        <div className="empty-state">
          <p>No partner hotels yet.</p>
          <p>We're onboarding hotels now. Check back soon.</p>
        </div>
      ) : (
        <div className="hotel-list">
          {hotels.map(hotel => (
            <div key={hotel.id} className="hotel-card">
              <div className="hotel-info">
                <h3>{hotel.name}</h3>
                <p className="hotel-address">{hotel.address}</p>
                <p className="hotel-chain">{hotel.chain}</p>
              </div>
              <div className="hotel-rate">
                <span className="rate">£{hotel.rate}</span>
                <span className="per-night">/night</span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
